import React, { useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomSelect_Orion from "./CustomSelect_Orion";
import {
  INIT_STATE_SELECTS,
  INDEX,
} from "../../../constants/driveglobalfilterinitalstates_orion";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_orion";
import { BsFillSkipForwardBtnFill } from "react-icons/bs";
import moment from "moment";
import $ from "jquery";
import { useEffect, useContext } from "react";
import AppContext from "../../../store/AppContext";
import useHttp from "../../../hook/use-http";
import { useLocation, Link } from "react-router-dom";

import { useSelector } from 'react-redux';
import { selectCityDepo } from '../../../redux/cityDepoSlice';

export default function Drive_Filter_Orion(props) {
  const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  const [changedColumn, setChangedColumn] = useState("");
  const [columnfilters, setcolumnfilters] = useState([]);
  const [refdate, setRefDate] = useState();
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [singleBtn, setsingleBtn] = useState(false);
  const inputElement = useRef();
  const socref = useRef();
  let location = useLocation();
  let path_check = location.pathname;
  const lastSegment = path_check.split("/").pop();

  // code to get city_depo from redux
  const [userCityDepo, setUserCityDepo] = useState({})
  const cityDepoAccess = useSelector(selectCityDepo);
  // code to get city_depo from redux

  const updateFilter = (arr, index) => {
    let state_ind = INDEX[index];
    setFilterData((prestate) => {
      return { ...filterdata, [state_ind]: arr };
    });
    setChangedColumn(index);
    if (columnfilters.indexOf(index) == -1) {
      setcolumnfilters([...columnfilters, index]);
    }
  };

  const vinnumChanged = (e) => {
    let enterter_vin = e.target.value;
    if (enterter_vin != "") {
      let new_vin = enterter_vin.split(",");

      if (new_vin.length == 1) {
        // setsingleBtn(true);
      }
      setChangedColumn("VIN_NUM");
      let VIN_NUM = "VIN_NUM";
      setFilterData((prestate) => {
        return { ...filterdata, VIN_NUM: new_vin };
      });
      if (columnfilters.indexOf("VIN_NUM") == -1) {
        setcolumnfilters([...columnfilters, "VIN_NUM"]);
      }
    }
  };

  const startDateChanged = (date) => {
    let sDate = "startDate";
    setChangedColumn("startDate");
    setFilterData((prestate) => {
      return { ...filterdata, [sDate]: date };
    });
    if (columnfilters.indexOf("START_DATE") == -1) {
      setcolumnfilters([...columnfilters, "START_DATE"]);
    }
  };

  const endDateChanged = (date) => {
    let eDate = "endDate";
    setChangedColumn("endDate");
    setFilterData((prestate) => {
      return { ...filterdata, [eDate]: date };
    });
    if (columnfilters.indexOf("END_DATE") == -1) {
      setcolumnfilters([...columnfilters, "END_DATE"]);
    }
  };

  const changeSoc = (e) => {
    setChangedColumn("SOC_INDEX");
    setFilterData((prestate) => {
      return { ...filterdata, SOC: parseInt(e.target.value) };
    });
    if (columnfilters.indexOf("SOC_INDEX") == -1) {
      setcolumnfilters([...columnfilters, "SOC_INDEX"]);
    }
  };

  const [toHIdeShowRCA, setToHIdeShowRCA] = useState("d-none")
  const [toSendChasisRCA, setToSendChasisRCA] = useState(0)
  const [depoErrMsg, setDepoErrMsg] = useState("")
  const onsubmit = (e) => {
    setDepoErrMsg("")
    e.preventDefault();
    if (userCityDepo.depot.length === 0) {
      if (filterdata.VIN_NUM.length === 1) {
        setToHIdeShowRCA("d-inline-block")
        setsingleBtn(true);
        setToSendChasisRCA(filterdata.VIN_NUM[0])
      }
      props.onsubmit(filterdata);
    } else {
      if (filterdata.DEPO.length === 0) {
        setDepoErrMsg("Please select at least 1 depot")
      } else {
        if (filterdata.VIN_NUM.length === 1) {
          setToHIdeShowRCA("d-inline-block")
          setsingleBtn(true);
          setToSendChasisRCA(filterdata.VIN_NUM[0])
        }
        props.onsubmit(filterdata);
      }
    }
  };

  const onreset = (e) => {
    window.location.reload(true);
  };

  const secondPageCilcked = () => {
    props.onsubmit({ ...filterdata, pageSelected: 2 });
  };

  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  };
  const appyData = (data) => {
    const res_result = data;

    setRefDate(res_result.value_as_string);
    refdate = res_result.value_as_string;
  };
  useEffect(() => {
    if (lastSegment === "driveanalysis_orion") {
      fetchData({ url: API_URL_MAIN + "orion_drive_api/driveanalysis_orion_refreshdate", body: {} }, appyData);
    }
    if (props.gloablfilter.DEPO.length > 0) {
      setcolumnfilters([...columnfilters, "DEPO_INDEX"])
    }
    setUserCityDepo(cityDepoAccess)
  }, []);

  return (
    <>
      <div className="container-fluid pt-3 cardBox busdrpg1">
        <div className="card">
          <div className="card-body busflt">
            <div className="row d-flex justify-content-between">
              <div className="col-lg-4 col-sm-4 d-flex align-items-center justify-content-right">
                <p className="small mb-0">Last Refresh Date: {refdate}</p>
              </div>
              <div className="col-lg-4 col-sm-4 d-flex align-items-center justify-content-center">
                <h5 className="mb-0 font-bus-head">Drive Analysis
                </h5>
              </div>

              <div className="col-lg-4 col-sm-4 text-end filter_bus_icon_f">
                {/* <div className={`rca_btn ${toHIdeShowRCA}`}>
                  <Link to={`/dashboard_orion/rca_bus/${toSendChasisRCA}`}>
                    <button type="button" className="btn text-white rca_btn_bus mr-1"><i className="fa fa-cogs"></i><b>&nbsp;&nbsp;RCA</b></button>
                  </Link>
                </div> */}
                <div className="text-end d-inline-block">
                  <button type="button" id="filterIcon" onClick={filterHideShow} className="btn btn-sm btn-outline-primary material-icons filter_bus_icon">filter_alt</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid busdrpg1">
        <div
          className="FilterDiv_bus p-2 mb-3"
          id="filterSearch"
          style={{ display: "none", zIndex: 1 }}
        >
          <form className="g-3 mt-2 filterForm">
            <div className="row">
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label_bus">Start Date</label>
                  <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2025-01-01T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata.startDate} onChange={startDateChanged} />
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlInput2" className="form-label_bus">End Date</label>
                  <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2025-01-01T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata.endDate} onChange={endDateChanged} />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlInput2" className="form-label_bus">Chassis No / Reg No</label>
                  <input autoComplete="off" defaultValue={filterdata.VIN_NUM.join(",")} className="top-filter filter-col" placeholder="Chassis No / Reg No" id="vin_num" ref={inputElement} onBlur={vinnumChanged} />
                </div>
              </div>
              
               <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Orion columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="CITY" IND="CITY_INDEX" updateFilter={updateFilter} cty_depo="true" ></CustomSelect_Orion>
                </div>
              </div>
              {/* <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Orion columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="DEPOT" IND="DEPO_INDEX" updateFilter={updateFilter} cty_depo="true" ></CustomSelect_Orion>
                  <p className="text-danger text-center" style={{ fontSize: "12px" }}><b>{depoErrMsg}</b></p>
                </div>
              </div>  */}
              {/* </div>
            <div className="row"> */}

              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Orion columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="LOB" IND="LOB_INDEX" updateFilter={updateFilter} ></CustomSelect_Orion>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Orion columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="PPL" IND="PPL_INDEX" updateFilter={updateFilter} ></CustomSelect_Orion>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Orion columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="PL" IND="PL_INDEX" updateFilter={updateFilter} ></CustomSelect_Orion>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Orion columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="AC Type" IND="AIR_VENTILATION_INDEX" updateFilter={updateFilter} ></CustomSelect_Orion>
                </div>
              </div>

              {/* <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlInput2" className="select_col_title_bus" >Discharge SOC % Diff.</label>
                  <select className="form-select react-select__option1" aria-label="Default select example" onChange={changeSoc} ref={socref} >
                    <option value={0}>All</option>
                    <option value={20}>&gt;20%</option>
                    <option value={40}>&gt;40%</option>
                    <option value={60}>&gt;60%</option>
                    <option value={80}>&gt;80%</option>
                  </select>
                </div>
              </div> */}
              <div className="col-lg-1 col-md-6 col-sm-12 bus_filtr_btn filter_bus_icon_f">
                <div className="mt-2">
                  <label className="form-label_bus" />
                  <button type="submit" className="form-control btn btn_bus btn-primary" onClick={onsubmit}>
                    Search
                  </button>
                </div>
              </div>
              <div className="col-lg-1 col-md-6 col-sm-12 bus_filtr_btn filter_bus_icon_f">
                <div className="mt-2">
                  <label className="form-label_bus" />
                  {/* <button type="submit" className="form-control btn btn-secondary" onClick={onreset} >
                    Reset
                  </button> */}
                  <Link>
                    <button type="button" className="form-control btn btn-secondary" onClick={onreset}>Reset</button>
                  </Link>
                </div>
              </div>
              {singleBtn && (<>
                <div className="col-lg-1 col-md-6 col-sm-12 bus_filtr_btn filter_bus_icon_f">
                  <div className="mt-2">
                    <label className="form-label_bus" />
                    <button className="form-control btn  btn-primary" onClick={secondPageCilcked} >
                      <BsFillSkipForwardBtnFill />
                    </button>
                  </div>
                </div>
              </>
              )}
            </div>
          </form>
        </div>
      </div >
    </>
  );
}
